import { Link } from "react-router-dom";
import { siteInfo } from "@/mocks/articles";

export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-foreground-950 text-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-14 md:py-16">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-10">
          <div>
            <h4 className="text-lg font-heading font-semibold mb-4">
              {siteInfo.name}
            </h4>
            <p className="text-sm text-background-50/70 leading-relaxed max-w-xs">
              {siteInfo.tagline}
            </p>
          </div>

          <div>
            <h4 className="text-sm font-semibold mb-4 text-background-50/90">
              快速导航
            </h4>
            <div className="flex flex-col gap-2">
              <Link
                to="/"
                className="text-sm text-background-50/60 hover:text-background-50 transition-colors whitespace-nowrap"
              >
                首页
              </Link>
              <Link
                to="/category/gurien-xiangchu"
                className="text-sm text-background-50/60 hover:text-background-50 transition-colors whitespace-nowrap"
              >
                闺蜜相处
              </Link>
              <Link
                to="/category/jiemei-qinggan"
                className="text-sm text-background-50/60 hover:text-background-50 transition-colors whitespace-nowrap"
              >
                姐妹情感
              </Link>
              <Link
                to="/about"
                className="text-sm text-background-50/60 hover:text-background-50 transition-colors whitespace-nowrap"
              >
                关于我们
              </Link>
            </div>
          </div>

          <div>
            <h4 className="text-sm font-semibold mb-4 text-background-50/90">
              联系方式
            </h4>
            <p className="text-sm text-background-50/60 mb-4">
              邮箱：{siteInfo.email}
            </p>
            <div className="flex items-center gap-4">
              <a
                href={siteInfo.socialLinks.weibo}
                className="w-8 h-8 flex items-center justify-center rounded-full bg-background-50/10 hover:bg-background-50/20 transition-colors cursor-pointer"
                aria-label="微博"
              >
                <i className="ri-weibo-line text-background-50 text-base"></i>
              </a>
              <a
                href={siteInfo.socialLinks.xiaohongshu}
                className="w-8 h-8 flex items-center justify-center rounded-full bg-background-50/10 hover:bg-background-50/20 transition-colors cursor-pointer"
                aria-label="小红书"
              >
                <i className="ri-red-packet-line text-background-50 text-base"></i>
              </a>
            </div>
          </div>
        </div>

        <div className="mt-12 pt-6 border-t border-background-50/10">
          <p className="text-xs text-background-50/40 text-center">
            &copy; {currentYear} {siteInfo.name}。保留所有权利。
          </p>
        </div>
      </div>
    </footer>
  );
}